/**
 * RichText, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/RichTextComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

/**
 * RichText's text as a plain string, whichever shape it arrived in.
 *
 * Meta accepts `text` as a string OR an array of strings, and our builder only ever writes the
 * string. That was fine until a flow authored elsewhere came the other way: hydrating an array
 * put it straight into the builder property, and `validateProperties` then called `.trim()` on
 * an Array and threw `TypeError: properties.text.trim is not a function`, an import that
 * crashed rather than a flow that failed validation. Joining on newline keeps every line and
 * gives the single text field the builder edits with.
 */
function asText(value) {
  if (Array.isArray(value)) {
    return value.join('\n');
  }
  return value || '';
}

export const RichTextCore = {
  type: 'RichText',
  name: 'Rich Text',
  icon: '📄',
  description: 'Markdown-formatted text block for headings, lists, and emphasis.',
  category: 'display',
  maxPerScreen: 1, // Cannot combine with other components except Footer in v6.3+

  getDefaultProperties() {
    return {
      text: '# Welcome\n\nThis is **rich text** with *formatting*.\n\n- Bullet point 1\n- Bullet point 2\n\n[Learn more](https://example.com)',
      visible: true,
    };
  },
  getPropertySchema() {
    return {
      text: {
        type: 'string',
        label: 'Markdown Content',
        required: true,
        multiline: true,
      },
      visible: {
        type: 'boolean',
        label: 'Visible',
        required: false,
      },
    };
  },
  validateProperties(properties) {
    var errors = [];
    var warnings = [];
    var text = asText(properties.text);

    if (!text || text.trim().length === 0) {
      errors.push('Text content is required');
    }

    if (text && text.length > 4096) {
      errors.push('Text content must be 4096 characters or less');
    }

    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    var result = {
      type: 'RichText',
      text: properties.text,
    };

    if (properties.visible === false) {
      result.visible = false;
    }

    return result;
  },
  transformFromWhatsApp(whatsappComponent) {
    return {
      text: asText(whatsappComponent.text),
      visible: whatsappComponent.visible !== false,
    };
  },
};
